import { useMediaQuery } from "@crehana/react-hooks";
import { Col, Container, Row, Skeleton } from "@crehana/ui";
import { LastActivityCourseCardSkeleton } from "../../../../../../../components/Cards/LastActivityCourseCard";
import { useLearnLastActivityContext } from "../../../../../hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var UserEnrolledSkeleton = function UserEnrolledSkeleton(_ref) {
  var _Col, _Col2, _Row;
  var _ref$withContainer = _ref.withContainer,
    withContainer = _ref$withContainer === void 0 ? false : _ref$withContainer,
    dataTestId = _ref['data-testid'];
  var _useMediaQuery = useMediaQuery('sm'),
    isSm = _useMediaQuery.matches;
  var _useLearnLastActivity = useLearnLastActivityContext(),
    isDark = _useLearnLastActivity.isDark,
    containerType = _useLearnLastActivity.containerType;
  var renderSkeleton = function renderSkeleton(testId) {
    if (isSm) {
      return /*#__PURE__*/_jsxs(Row, {
        nowrap: true,
        "data-testid": testId,
        children: [_Col || (_Col = /*#__PURE__*/_jsx(Col, {
          lg: 6,
          children: /*#__PURE__*/_jsx(LastActivityCourseCardSkeleton, {
            isDark: isDark
          })
        })), _Col2 || (_Col2 = /*#__PURE__*/_jsxs(Col, {
          lg: 6,
          children: [/*#__PURE__*/_jsx(Skeleton, {
            className: "w-full h-160 rounded-5 mb-16",
            isDark: isDark
          }), /*#__PURE__*/_jsx(Skeleton, {
            className: "w-full h-144 rounded-5",
            isDark: isDark
          })]
        }))]
      });
    }
    return _Row || (_Row = /*#__PURE__*/_jsx(Row, {
      nowrap: true,
      children: /*#__PURE__*/_jsx(Col, {
        children: /*#__PURE__*/_jsx(LastActivityCourseCardSkeleton, {
          isDark: isDark
        })
      })
    }));
  };
  if (withContainer) {
    return /*#__PURE__*/_jsx(Container, {
      type: containerType,
      "data-testid": dataTestId,
      children: renderSkeleton()
    });
  }
  return renderSkeleton(dataTestId);
};
export default UserEnrolledSkeleton;